import React from "react";
import { Header } from "../../components/Header";
import { useTranslation } from "react-i18next";
import { ProductBanner } from "../../blocks/product-banner";
import { CommonPageLink } from "../../blocks/common-page-link";
import { GatewayIntegrationFeature } from "../../blocks/gateway-integration-features";
import { GatewayIntegrationFunctions } from "../../blocks/gateway-integration-functions";
import { HomeTryOn } from "../../blocks/home-try-on";
import "./styles.less";
import { GatewayIntegrationProcess } from "../../blocks/gateway-integration-process";
import { Footer } from "../../components/Footer";
export const GatewayIntegrationPage = (props) => {
  const { isMobile } = props;
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  const bannerData = {
    title: "gateway.banner.title",
    subTitle: "gateway.banner.subtitle",
    bannerImg: {
      src: "//files.authing.co/authing-website/gateway-banner-img.png",
      alt: "authing employee-identity-manage",
    },
    bannerBG: {
      src: "//files.authing.co/authing-website/gateway-banner-img-bg.png",
      alt: "authing",
    },
  };

  return (
    <div className="gateway-integration-page">
      <Header mode="light" isMobile={isMobile} />
      <ProductBanner {...bannerData} />
      <GatewayIntegrationFeature />
      <GatewayIntegrationFunctions />
      <GatewayIntegrationProcess />
      <CommonPageLink pagesLink={pagesLink} />
      <div className="gateway-homeTryOn-bg">
        <HomeTryOn />
      </div>
      <Footer />
    </div>
  );
};
